import React from 'react'
import { Button } from 'react-bootstrap'
import Loader from './Loader'

const AppButton = ({ type, isLoading, handleClick, title, className }) => {

    return (
        <Button
            className={`${className} mb-3 btn btn-danger px-4 py-2`}
            type={type}
            onClick={handleClick}
        >
            {isLoading ? <Loader /> : title
            }
        </Button >
    )
}

export default AppButton